import { withRouter } from 'react-router-dom';
import { Box, Typography, Grid } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import InfoIcon from '@material-ui/icons/Info';
import BariatricsIcon from '../../../images/BariatricsIcon.png'

import styles from './Bariatrics.style';
import { useTranslation } from 'react-i18next';
import { MobileRegularPage } from '../../../components';
import { AppButton } from "../components/InputComponents";
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useState, useEffect } from 'react';


const cookies = new Cookies();

const SaveResult = (props) => {
    const classes = styles();
  
    const { t } = useTranslation();
    return (
        <MobileRegularPage>

            <Box className={classes.title}>
                <Box>
                <img src={BariatricsIcon} style={{width:'100px', height:'100px'}} />
                </Box>
                <Typography variant="h3">Your Bariatrics Saved Successfully</Typography>
            </Box>
           
            < AppButton
                style={{ marginTop: "20px" }}
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                component={Link}
                to="/app/dashboard"
                onClick={props.scrollToTop}
            >
                Back To Dashboard
            </AppButton>

        </MobileRegularPage >

    );
}

export default withRouter(SaveResult);